import { useCallback, useState } from 'react';
import { InlineStack, Popover, PopoverContent } from '@customerio/pluma-components/react';
import { HelpButton } from '@/features/help-sidebar';
import { useOnPathChange } from '@/services/router/use-on-path-change';
import { IconButton } from '../icon-button';
import { NotificationsDrawer } from '../notifications-drawer';
import { NotificationsDropdown } from '../notifications-dropdown';
import { PersonDropdown } from '../person-dropdown';

type MoreMenuProps = {
  notificationsUxEnabled: boolean;
};

/**
 * The header's Help, Notifications and Settings buttons behind one button, for below `md`.
 * Each opens its own surface, as it does in the header.
 *
 * Help closes this popover, so it doesn't sit over the help sidebar. Notifications leaves
 * it open: its drawer or popover renders from inside this one and would close with it.
 */
export function MoreMenu({ notificationsUxEnabled }: MoreMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => setIsOpen(false), []);

  // A link in the person menu, say.
  useOnPathChange(close);

  return (
    <Popover isOpen={isOpen} onOpenChange={setIsOpen} placement="bottom-end" withArrow={false}>
      {(context) => (
        <IconButton
          label="More"
          icon="more"
          size="md"
          ref={context.reference.setReference}
          {...context.reference.getReferenceProps()}
        />
      )}
      <PopoverContent p="100">
        <InlineStack alignBlock="center" gap="075">
          <HelpButton onClick={close} />
          {notificationsUxEnabled ? <NotificationsDrawer /> : <NotificationsDropdown />}
          <PersonDropdown />
        </InlineStack>
      </PopoverContent>
    </Popover>
  );
}
